import { render, staticRenderFns } from "./settings-flex.vue?vue&type=template&id=9b150648&"
import script from "./settings-flex.vue?vue&type=script&lang=js&"
export * from "./settings-flex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports